import { IconX } from "@tabler/icons-react";
import PrimaryButton from "../../../components/PrimaryButton";
import InputField from "../../../components/common/InputField";
import NewSelectInput from "../../../components/NewSelectInput";
import { useLanguage } from "../../../context/LanguageContext";

type Props = {
  onClose: () => void;
  setFilters: any;
};

export default function FilterSidebarLog({ onClose, setFilters }: Props) {
  const { t } = useLanguage();

  const UserTypeData = [
    { id: 1, value: "client", text: t("Client") },
    { id: 2, value: "admin", text: t("Admin") },
    { id: 3, value: "driver", text: t("Driver") },
    { id: 4, value: "staff", text: t("Staff") },
  ];
  const ActivityTypeData = [
    { id: 1, value: "client", text: t("Vehicle") },
    { id: 2, value: "admin", text: t("Clients") },
    { id: 3, value: "driver", text: t("Shipment Manifest") },
    { id: 4, value: "staff", text: t("Activity Logs") },
  ];

  return (
    <div className="h-full w-full bg-white rounded-l-3xl flex flex-col justify-between">
      {/* Header */}
      <div>
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-lg font-semibold">{t("Logs Filter")}</h2>
          <button
            onClick={onClose}
            className="bg-[#F7F6F2] rounded-full p-1 cursor-pointer"
          >
            <IconX size={24} />
          </button>
        </div>
        <div className="p-4 space-y-4">
          <InputField label={t("User Name")} placeholder="Jhon Singh" />
          <NewSelectInput
            label={t("User Type")}
            name="userType"
            selectOptions={UserTypeData}
          />
          <InputField label={t("Warehouse")} placeholder="Jaipur" />
          <NewSelectInput
            label={t("Activity Type")}
            name="activityType"
            selectOptions={ActivityTypeData}
          />
          <InputField label={t("Date")} type="date" />
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-2 bg-white sticky bottom-0">
        <PrimaryButton label={t("Apply Filters")} />
      </div>
    </div>
  );
}
